/* Freebie Landing – MostFocused. Konfiguration kommt aus data-* am Formular. */
(() => {
  const d = document, w = window;
  const qs = new URLSearchParams(location.search);
  const dry = qs.get('fl_dry');
  const reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  /* In-App-Browser (TikTok, Instagram, Facebook) – dort scheitern Anfragen an Klaviyo teilweise */
  const UA = navigator.userAgent || '';
  const INAPP = /musical_ly|BytedanceWebview|TikTok|trill_/i.test(UA) ? 'tiktok'
    : /Instagram/i.test(UA) ? 'instagram'
    : /FBAN|FBAV|FB_IAB/i.test(UA) ? 'facebook' : '';
  const APP = { tiktok: 'TikTok', instagram: 'Instagram', facebook: 'Facebook' }[INAPP];
  const MSG = {
    invalid: 'Bitte prüf deine E-Mail-Adresse.',
    network: 'Das hat gerade nicht geklappt. Prüf deine Verbindung und versuch’s nochmal.',
    inapp: 'In der ' + APP + '-App klappt die Anmeldung gerade nicht. Tipp oben rechts auf ••• → „Im Browser öffnen“ – dann geht’s sofort.'
  };
  const ERR_KEY = 'fl_last_error';
  const store = {
    get: () => { try { return JSON.parse(localStorage.getItem(ERR_KEY) || 'null'); } catch (e) { return null; } },
    set: (v) => { try { v ? localStorage.setItem(ERR_KEY, JSON.stringify(v)) : localStorage.removeItem(ERR_KEY); } catch (e) {} }
  };

  const track = (name, data) => {
    console.info('[fl] event', name, data || '');
    if (name === 'freebie_signup' && w.ttq) w.ttq.track('CompleteRegistration', { content_name: 'Lernplan Vorlage' });
    if (w.Shopify && w.Shopify.analytics && w.Shopify.analytics.publish) w.Shopify.analytics.publish(name, data || {});
  };

  /* Ein Versuch per fetch (mit Zeitlimit) */
  const viaFetch = (url, body) => {
    const ctl = 'AbortController' in w ? new AbortController() : null;
    const t = ctl && setTimeout(() => ctl.abort(), 10000);
    return fetch(url, {
      method: 'POST',
      headers: { revision: '2024-10-15', 'content-type': 'application/json' },
      body, signal: ctl ? ctl.signal : undefined
    }).then(r => r.status, x => { const e = new Error('fetch: ' + (x && x.name || 'error')); e.kind = 'network'; throw e; })
      .finally(() => t && clearTimeout(t));
  };

  /* Ein Versuch per XMLHttpRequest – anderer Transportweg, falls In-App-Browser fetch stören */
  const viaXhr = (url, body) => new Promise((ok, fail) => {
    const x = new XMLHttpRequest();
    x.open('POST', url, true);
    x.timeout = 10000;
    x.setRequestHeader('revision', '2024-10-15');
    x.setRequestHeader('content-type', 'application/json');
    const net = (k) => () => { const e = new Error('xhr: ' + k); e.kind = 'network'; fail(e); };
    x.onload = () => x.status ? ok(x.status) : net('status0')();
    x.onerror = net('error'); x.ontimeout = net('timeout'); x.onabort = net('abort');
    x.send(body);
  });

  const wait = (ms) => new Promise(r => setTimeout(r, ms));

  const subscribe = async (f, email) => {
    if (dry) { await wait(1200); if (dry === 'error') { const e = new Error('dry'); e.kind = 'network'; throw e; } return; }
    const props = { signup_source: f.dataset.source };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(k => { if (qs.get(k)) props[k] = qs.get(k); });
    if (INAPP) props.signup_inapp = INAPP;
    const prev = store.get();
    if (prev) props.signup_prev_error = prev.msg + ' @ ' + prev.at; // früherer Fehlschlag auf diesem Gerät → sichtbar in Klaviyo
    const attrs = { email, properties: props };
    const first = f.elements.first_name;
    if (first && first.value.trim()) attrs.first_name = first.value.trim();
    const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + f.dataset.companyId;

    /* 3 Versuche: fetch → XHR → fetch (mit kurzer Pause). Nur Netzwerkfehler/5xx/429 werden wiederholt. */
    const plan = [[viaFetch, 0], [viaXhr, 600], [viaFetch, 1500]];
    let last;
    for (let i = 0; i < plan.length; i++) {
      const [send, pause] = plan[i];
      if (pause) await wait(pause);
      props.signup_attempt = i + 1;
      props.signup_transport = send === viaXhr ? 'xhr' : 'fetch';
      const body = JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: f.dataset.customSource,
        profile: { data: { type: 'profile', attributes: attrs } }
      }, relationships: { list: { data: { type: 'list', id: f.dataset.listId } } } } });
      try {
        const status = await send(url, body);
        if (status >= 200 && status < 300) { store.set(null); return; }
        last = new Error('http ' + status); last.status = status;
        if (status >= 400 && status < 500 && status !== 429) { last.kind = 'invalid'; throw last; }
        last.kind = 'network';
      } catch (x) {
        if (x.kind === 'invalid') throw x;
        last = x;
      }
    }
    store.set({ msg: String(last && last.message || 'unknown').slice(0, 60), at: new Date().toISOString().slice(0, 16), inapp: INAPP });
    throw last;
  };

  const forms = [...d.querySelectorAll('[data-fl-form]')];
  let done = false;

  const finish = (src) => {
    done = true;
    d.querySelectorAll('[data-fl-success-scope]').forEach(s => s.classList.add('fl-done'));
    const msg = src.closest('[data-fl-success-scope]').querySelector('.fl-success');
    if (msg) msg.focus({ preventScroll: true });
    sticky(false);
    track('freebie_signup', { page: 'lernplan_v2', form: src.dataset.flForm });
  };

  forms.forEach(f => {
    const input = f.elements.email, err = f.querySelector('.fl-form__error'), btn = f.querySelector('button');
    const field = input.closest('.fl-form__field');
    const setErr = (m) => { err.textContent = m || ''; field.classList.toggle('fl-form__field--invalid', !!m); input.setAttribute('aria-invalid', m ? 'true' : 'false'); };
    input.addEventListener('input', () => { if (err.textContent) setErr(''); });
    f.addEventListener('submit', (e) => {
      e.preventDefault();
      if (f.classList.contains('fl-form--loading')) return;
      if (f.elements.website && f.elements.website.value) return finish(f); // Honeypot: still „Erfolg“
      const email = input.value.trim();
      if (!EMAIL.test(email)) { setErr(MSG.invalid); input.focus(); return; }
      setErr('');
      f.classList.add('fl-form--loading'); btn.disabled = true;
      subscribe(f, email)
        .then(() => finish(f))
        .catch(x => {
          track('freebie_signup_error', { page: 'lernplan_v2', form: f.dataset.flForm, error: String(x && x.message), status: x && x.status || 0, inapp: INAPP || 'none' });
          setErr(x && x.kind === 'invalid' ? MSG.invalid : INAPP ? MSG.inapp : MSG.network);
        })
        .finally(() => { f.classList.remove('fl-form--loading'); btn.disabled = false; });
    });
  });

  /* Fixierter Button */
  const stickyEl = d.querySelector('[data-fl-sticky]'), hero = forms[0], final = d.querySelector('.fl-final');
  const seen = new Map();
  function sticky(show) {
    if (!stickyEl) return;
    stickyEl.classList.toggle('fl-sticky--visible', show);
    stickyEl.setAttribute('aria-hidden', String(!show));
    stickyEl.querySelector('button').tabIndex = show ? 0 : -1;
  }
  if (stickyEl && hero && 'IntersectionObserver' in w) {
    const io = new IntersectionObserver(es => {
      es.forEach(e => seen.set(e.target, e.isIntersecting));
      const heroGone = !seen.get(hero) && hero.getBoundingClientRect().bottom < 0;
      sticky(!done && heroGone && !seen.get(final));
    });
    io.observe(hero); if (final) io.observe(final);
  }
  /* Sticky-Button + Abschluss-Button: weich zum Formular, Cursor ins erste Feld */
  d.querySelectorAll('[data-fl-sticky] button, [data-fl-to-form]').forEach(b => b.addEventListener('click', () => {
    if (!hero) return;
    track(b.closest('[data-fl-sticky]') ? 'freebie_sticky_click' : 'freebie_final_click');
    hero.querySelector('.fl-form__input').focus({ preventScroll: true });
    hero.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  }));

  /* Punkte-Navigation */
  const makeDots = (box, n, label, onPick) => {
    for (let i = 0; i < n; i++) {
      const b = d.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', label + ' ' + (i + 1));
      b.onclick = (e) => { e.stopPropagation(); onPick(i); };
      box.append(b);
    }
    return (a) => [...box.children].forEach((b, i) => b.setAttribute('aria-current', String(i === a)));
  };

  /* Bilderband: Inhalt einmal duplizieren → nahtlose Endlosschleife */
  if (!reduce) d.querySelectorAll('[data-fl-marquee]').forEach(m => {
    const tr = m.firstElementChild, n = tr.children.length;
    [...tr.children].forEach(li => { const c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); tr.append(c); });
    m.style.setProperty('--fl-marquee-dur', n * 5 + 's');
    m.classList.add('fl-marquee--ready');
  });

  /* Kartenstapel „Das ist drin“ (Shuffle wie im Lerntyp-Quiz) */
  d.querySelectorAll('[data-fl-stack]').forEach(st => {
    const items = [...st.children], n = items.length, wrap = st.parentElement;
    const box = wrap.querySelector('[data-fl-stack-dots]'), hint = wrap.querySelector('.fl-stack__hint');
    if (n < 2) return;
    let cur = 0, seen = false, touched = 0, x0 = null, swiped = false;
    const mark = box ? makeDots(box, n, 'Karte', (i) => go(i, true)) : () => {};
    const render = () => { items.forEach((it, k) => { it.dataset.pos = (k - cur + n) % n; }); mark(cur); };
    function go(i, user) {
      const out = items[cur], next = (i + n) % n;
      if (next === cur) return;
      if (next === (cur + 1) % n && !reduce) {
        out.classList.add('fl-stack__out');
        setTimeout(() => out.classList.remove('fl-stack__out'), 380);
      }
      cur = next; render();
      if (user) touched = Date.now();
    }
    st.classList.add('fl-stack--ready'); if (hint) hint.classList.add('fl-stack__hint--ready');
    render();
    st.addEventListener('click', () => { if (!swiped) go(cur + 1, true); });
    st.addEventListener('pointerdown', (e) => { x0 = e.clientX; swiped = false; });
    st.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { swiped = true; go(cur + (dx < 0 ? 1 : -1), true); }
    });
    st.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(cur + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, true); }
    });
    if ('IntersectionObserver' in w) new IntersectionObserver(es => { seen = es[0].isIntersecting; }, { threshold: .6 }).observe(st);
    if (!reduce) setInterval(() => { if (seen && !d.hidden && Date.now() - touched > 6000) go(cur + 1); }, 2600);
  });

  /* Vorher/Nachher */
  d.querySelectorAll('[data-fl-compare]').forEach(c => {
    const r = c.querySelector('input');
    const upd = () => {
      const v = +r.value;
      c.style.setProperty('--fl-pos', v + '%');
      c.dataset.edge = v < 18 ? 'left' : v > 82 ? 'right' : '';
    };
    r.addEventListener('input', () => { c.classList.remove('fl-compare--hint'); upd(); }); upd();
    if (!reduce && 'IntersectionObserver' in w) {
      const io = new IntersectionObserver(es => {
        if (!es[0].isIntersecting) return;
        io.disconnect(); c.classList.add('fl-compare--hint');
        c.addEventListener('animationend', () => c.classList.remove('fl-compare--hint'), { once: true });
      }, { threshold: .6 });
      io.observe(c);
    }
  });
})();
